module.exports = __webpack_public_path__ + "static/media/settings.641f5801.svg";